"use client";

import { useState } from "react";
import Link from "next/link";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function HeroSignupCard({ user }: { user: any }) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [skillsAcknowledged, setSkillsAcknowledged] = useState(false);

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { createClient } = await import("@/libs/supabase/client");
      const supabase = createClient();
      const redirectURL = window.location.origin + "/api/auth/callback";

      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: redirectURL,
          data: {
            signup_source: 'landing_hero',
            is_new_user: true
          }
        },
      });

      if (error) throw error;

      setIsSuccess(true);
    } catch (error) {
      console.error("Signup error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="card bg-base-100 shadow-xl border-2 border-primary/20 hover:border-primary/40 transition-colors">
      <div className="card-body">
        <div className="badge badge-primary mb-2">Do It Yourself</div>
        <h3 className="card-title text-xl">Lyric swap tools for PRODUCERS starting at $9/mo</h3>
        <ul className="space-y-2 text-base-content/70 my-4">
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">&#10003;</span>
            <span>Change lyrics, voices, and separate stems</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">&#10003;</span>
            <span>7-day free trial — cancel anytime</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">&#10003;</span>
            <span>For producers with DAW experience</span>
          </li>
        </ul>
        {isSuccess ? (
          <div className="alert alert-success">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Check your email! Magic link sent.</span>
          </div>
        ) : !user ? (
          skillsAcknowledged ? (
            <form onSubmit={handleSignup} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                aria-label="Email address"
                className="input input-bordered w-full"
                required
              />
              <button
                type="submit"
                className="btn btn-primary w-full"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="loading loading-spinner"></span>
                ) : (
                  "Start Free Trial"
                )}
              </button>
              <button
                type="button"
                onClick={() => setSkillsAcknowledged(false)}
                className="btn btn-ghost btn-xs w-full text-base-content/50"
              >
                Wait, I&apos;m not comfortable with audio editing
              </button>
            </form>
          ) : (
            <div className="space-y-3">
              <button
                type="button"
                onClick={() => setSkillsAcknowledged(true)}
                className="btn btn-primary w-full"
              >
                I have audio editing skills, continue
              </button>
              <Link href="/service" className="btn btn-ghost text-primary w-full">
                Not me, order a finished song instead
              </Link>
            </div>
          )
        ) : (
          <Link href="/dashboard" className="btn btn-primary w-full">
            Go to Dashboard
          </Link>
        )}
      </div>
    </div>
  );
}
